import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {guildsApi} from '../http/Api';

export const getGuilds = createAsyncThunk('guilds/getGuilds', async (_, thunkAPI) => {
  const response = await guildsApi.getGuilds();
  console.log('response', response);

  if (response.status === 200) {
    thunkAPI.dispatch(guildsSlice.actions.setGuilds(response));
  }
});

const initialState = {
  guildsGlobalState: null,
};

const guildsSlice = createSlice({
  name: 'guilds',
  initialState,
  reducers: {
    setGuilds: (state, action) => {
      state.guildsGlobalState = action.payload;
    },
  },
});

export const guilds = guildsSlice.reducer;
export const {setGuilds} = guildsSlice.actions;
